import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { Permission } from "@sbd-tcic/shared-types";
import { useAuth } from "../lib/auth";

export function ProtectedRoute({ children, permission }: { children: ReactNode; permission?: Permission }) {
  const { user, loading, can } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface text-ink-muted text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (permission && !can(permission)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <div className="card p-8 max-w-md text-center">
          <div className="text-lg font-bold mb-2">Access restricted</div>
          <p className="text-sm text-ink-muted">Your role ({user.role.replace(/_/g, " ")}) doesn't have permission to view this page.</p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
